import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const pwd = control.get('data.password');
  const confirmPwd = control.get('confirmPassword');

  return pwd.value === confirmPwd.value ? null : { passwordMismatch: true };
};
